import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { authApi, mydataError } from "@/api";
import { useLang } from "@/i18n";

export const ChangePasswordDialog = ({ open, onClose }) => {
  const { t } = useLang();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try { await authApi.changePassword(cur, nw); toast.success(t("password_changed")); setCur(""); setNw(""); onClose(); }
    catch (err) { toast.error(mydataError(err, t)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle className="font-heading">{t("change_password")}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-wider text-slate-500">{t("current_password")}</Label>
            <Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} autoComplete="current-password" className="font-mono" data-testid="current-password-input" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-wider text-slate-500">{t("new_password")}</Label>
            <Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} autoComplete="new-password" className="font-mono" data-testid="new-password-input" />
          </div>
          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={onClose}>{t("cancel")}</Button>
            <Button type="submit" disabled={saving || nw.length < 6} className="bg-blue-800 hover:bg-blue-700" data-testid="change-password-submit">{t("save")}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
